import React from "react";
import "./card.css";
import { toast } from "react-toastify";
import { useTranslation, Trans } from "react-i18next";

export default function FlipCard({ type, title, onclick, src, alt, url, className }) {
  const { t } = useTranslation();
  // `title` stays English (it's compared below); only the displayed label is translated
  const label = t(`shortcuts.cards.${title}`, { defaultValue: title });
  const isHelpFundCard = title === "Make Contribution";
  const isBookSessionCard = title === "Book Private Mediumship Session";
  const cardClasses = [
    "client-dashboard-card-container",
    "pointer",
    isHelpFundCard ? "flip-card help-fund-card" : "",
    isBookSessionCard ? "book-session-card" : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  // "Get Help" / "Report Issue" open an external URL or mailto link
  if (type === "mail") {
    const isMailto = url && url.startsWith("mailto:");

    // Show web-mail options instead of handing mailto to the OS, so the
    // compose window opens in the same browser the user is already using.
    const handleMailto = (e) => {
      e.preventDefault();
      const email = url.replace(/^mailto:/, "").split("?")[0];
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(email).catch(() => {});
      }
      const to = encodeURIComponent(email);
      const linkStyle = {
        display: "inline-block",
        marginRight: 12,
        marginTop: 8,
        color: "#d5a67b",
        fontWeight: 600,
        textDecoration: "underline",
      };
      toast.info(
        <div>
          <div>
            <Trans i18nKey="shortcuts.reportIssueToast" values={{ email }} />
          </div>
          <a
            style={linkStyle}
            href={`https://mail.google.com/mail/?view=cm&fs=1&to=${to}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Gmail
          </a>
          <a
            style={linkStyle}
            href={`https://outlook.live.com/mail/0/deeplink/compose?to=${to}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Outlook
          </a>
          <a style={linkStyle} href={url}>
            {t("shortcuts.emailApp")}
          </a>
        </div>,
        {
          toastId: "report-issue-mail",
          position: "top-center",
          autoClose: 10000,
          closeOnClick: false,
        }
      );
    };
    return (
      <a
        href={url}
        onClick={(e) => {
          localStorage.removeItem("activesession_id");
          localStorage.removeItem("type");
          localStorage.removeItem("offset");
          if (isMailto) handleMailto(e);
        }}
        {...(!isMailto && { target: "_blank", rel: "noopener noreferrer" })}
        className={cardClasses}
      >
        <div>
          <img src={src} alt={alt} />
          <p>{label}</p>
        </div>
      </a>
    );
  }

  return (
    <>
      <div
        onClick={onclick}
        className={cardClasses}
      >
        {isHelpFundCard ? (
          <div className="flip-inner">
            <div className="flip-front">
              <img src={src} alt={alt} />
              <p>{label}</p>
            </div>
            <div className="flip-back">
              <p>{t("shortcuts.helpFundBack")}</p>
            </div>
          </div>
        ) : (
          <div>
            <img src={src} alt={alt} />
            <p>{label}</p>
          </div>
        )}
      </div>
    </>
  );
}
